/**
 * 业务系统列定义.
 */

export default {
  code: 200,
  data: {
    items: [
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-edit',
        cssType: '',
        name: '编辑',
        showExp: '{{!!data.menuEditShow}}',
        param: {
          methodName: 'handleEditRowMenu',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-edit',
        cssType: '',
        name: '复制新建',
        showExp: '{{!!data.menuCopyAddShow}}',
        param: {
          methodName: 'handleToolbarMenuAdd',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-guanlian',
        cssType: '',
        name: '映射商品',
        showExp: '{{!!data.menuMapingShow}}',
        // "showExp": "{{!!data.menuDeleteShow}}",
        param: {
          methodName: 'handleMapingGoods',
        },
        enableExp: '',
      },
      {
        style: 'error',
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-delete',
        cssType: '',
        name: '删除',
        showExp: '{{!!data.menuDeleteShow}}',
        param: {
          methodName: 'handleDeleteRowMenu',
        },
        enableExp: '',
      },
    ],
  },
  msg: 'string',
  success: false,
}
